// useEffect(() => {
//   const params = new URLSearchParams(window.location.search);

//   const counsellorParam = params.get("counsellor");
//   let counsellorName = "";
//   if (counsellorParam) {
//     // Split at "*" and take the last part
//     counsellorName = counsellorParam.split("*").pop();
//   }

//   setFormData((prev) => ({
//     ...prev,
//     fullName: params.get("name") || prev.fullName,
//     telephone: params.get("mobile") || prev.telephone,
//     email: params.get("email") || prev.email,
//     counselingCenter: params.get("branch") || prev.counselingCenter,
//     counselorName: counsellorName || prev.counselorName,
//   }));

//   window.scrollTo(0, 0);

//   const encoded = sessionStorage.getItem("encodedFormData");
//   if (encoded) {
//     try {
//       const decoded = JSON.parse(decodeURIComponent(escape(atob(encoded))));
//       $("#name1").val(decoded.fullName || "");
//       $("#email1").val(decoded.email || "");
//       $("#phone1").val(decoded.telephone || "");
//       $("#course1").val(decoded.course || "");
//       $("#comment1").val(decoded.comments || "");
//       $("#amount1").val(decoded.payAmount || "");
//       $("#counselor1").val(decoded.counselorName || "");
//     } catch (err) {
//       console.error("Failed to decode form data:", err);
//     }
//   }
// }, []);

// const [formData, setFormData] = useState({
//   fullName: "",
//   telephone: "",
//   email: "",
//   counselingCenter: "",
//   counselorName: "",
// });
import React, { useEffect, useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import {
  Form,
  Row,
  Col,
  Card,
  Badge,
  ListGroup,
  Button,
} from "react-bootstrap";
import axios from "axios";
import $ from "jquery";
import bannerImage from "../../Images/Banner/online-payment.webp";
import razorpay from "../../Images/companylogo/razorpayLogo.png";
import basispay from "../../Images/companylogo/basispayLogo.jpg";
import CourseList from "./CourseList";

const OnlinePayment = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    telephone: "",
    email: "",
    counselingCenter: "",
    counselorName: "",
    course: "",
    comments: "",
    payAmount: "",
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    let decodedParams = null;

    // 1. Check if URL has ?data= (Base64 encoded)
    const encodedData = params.get("data");
    if (encodedData) {
      try {
        const decoded = decodeURIComponent(escape(atob(encodedData)));
        decodedParams = new URLSearchParams(decoded);
      } catch (err) {
        console.error("Failed to decode Base64 data:", err);
      }
    }

    // 2. Use decodedParams if available, else fall back to normal params
    const sourceParams = decodedParams || params;

    const counsellorParam = sourceParams.get("counsellor");
    let counsellorName = counsellorParam ? counsellorParam.split("*").pop() : "";

    // 🔹 Update React state
    setFormData((prev) => ({
      ...prev,
      fullName: sourceParams.get("name") || prev.fullName,
      telephone: sourceParams.get("mobile") || prev.telephone,
      email: sourceParams.get("email") || prev.email,
      counselingCenter: sourceParams.get("branch") || prev.counselingCenter,
      payAmount: sourceParams.get("amount") || prev.payAmount,
      counselorName: counsellorName || prev.counselorName,
    }));

    // 🔹 Autofill visible inputs
    $("#name1").val(sourceParams.get("name") || "");
    $("#email1").val(sourceParams.get("email") || "");
    $("#phone1").val(sourceParams.get("mobile") || "");
    $("#counselor1").val(counsellorName || "");
    $("#amount1").val(sourceParams.get("amount") || "");
    $("#branch1").val(sourceParams.get("branch") || "");

    // 3. Handle sessionStorage if present
    const encoded = sessionStorage.getItem("encodedFormData");
    if (encoded) {
      try {
        const decoded = JSON.parse(decodeURIComponent(escape(atob(encoded))));

        setFormData((prev) => ({
          ...prev,
          fullName: decoded.fullName || prev.fullName,
          telephone: decoded.telephone || prev.telephone,
          email: decoded.email || prev.email,
          course: decoded.course || prev.course,
          comments: decoded.comments || prev.comments,
          payAmount: decoded.payAmount || prev.payAmount,
          counselorName: decoded.counselorName || prev.counselorName,
        }));

        // Autofill from sessionStorage too
        $("#name1").val(decoded.fullName || "");
        $("#email1").val(decoded.email || "");
        $("#phone1").val(decoded.telephone || "");
        $("#course1").val(decoded.course || "");
        $("#comment1").val(decoded.comments || "");
        $("#amount1").val(decoded.payAmount || "");
        $("#counselor1").val(decoded.counselorName || "");
      } catch (err) {
        console.error("Failed to decode form data from sessionStorage:", err);
      }
    }
  }, []);


  const handleRazorpay = async (e) => {
    e.preventDefault();

    const name = $("#name1").val();
    const email = $("#email1").val();
    const phone = $("#phone1").val();
    const amount = $("#amount1").val();
    const course = $("#course1").val();
    const comment = $("#comment1").val();

    if (!name || !email || !phone || !amount) {
      alert("Please fill in all required fields");
      return;
    }

    // 1️⃣ Create order_id from backend
    const orderRes = await axios.post(
      "https://isbmuniversity.edu.in/api/create_order.php",
      {
        amount: parseFloat(amount) * 100, // in paise
        currency: "INR",
      }
    );

    const { order_id } = orderRes.data;

    // 2️⃣ Open Razorpay checkout
    const options = {
      key: "rzp_live_bZvNUjzwu1aZE7",
      amount: parseFloat(amount) * 100,
      currency: "INR",
      name,
      description: "Online Fee Payment",
      order_id: order_id, // required for signature verification
      handler: async function (response) {
        // 3️⃣ Send payment details + form data to backend
        const payload = {
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
          name,
          email,
          phone,
          amount,
          course,
          comment,
        };

        const saveRes = await axios.post(
          "https://isbmuniversity.edu.in/api/save_payment.php",
          payload
        );

        if (saveRes.data.success) {
          window.location.href = saveRes.data.redirect;
        } else {
          alert("Payment succeeded but failed to save!");
        }
      },
      prefill: { name, email, contact: phone },
      notes: { course, comment },
      theme: { color: "#1c2447" },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  async function getData(e) {
    e.preventDefault();

    var name = $("#name1").val();
    var email = $("#email1").val();
    var amount = $("#amount1").val();
    var phone = $("#phone1").val();
    var course = $("#course1").val();
    var comment = $("#comment1").val();
    var orderid = Date.now();
    let input = {
      email: email,
      name: name,
      amount: amount,
      return_url: "https://isbmuniversity.edu.in/api/payment_response.php",
      order_id: orderid,
      mode: "LIVE",
      currency: "INR",
      description: "Payment Gateway",
      phone: phone,
      address_line_1: "Lalji Pada",
      address_line_2: "Kandivali West",
      city: "Mumbai",
      state: "Maharashtra",
      zip_code: "400051",
      country: "India",
      udf1: course,
      udf2: comment,
      udf3: "",
      udf4: "",
      udf5: "",
    };

    console.log(input);
    await axios
      .post("https://isbmuniversity.edu.in/api/payment_proceed.php", input)
      .then((response) => {
        $('input[name="amount"]').val(amount);
        $('input[name="name"]').val(name);
        $('input[name="email"]').val(email);
        $('input[name="phone"]').val(phone);
        $('input[name="order_id"]').val(orderid);
        $('input[name="udf1"]').val(course);
        $('input[name="udf2"]').val(comment);
        $('input[name="hash"]').val(response.data.data);
        $("#tnpForm1").attr(
          "action",
          "https://pay.basispay.in/v2/paymentrequest"
        );
        $("#tnpForm1").submit();
      });
  }
  return (
    <>
      <title>Pay Fees Online – ISBM University | Fast & Secure Payments</title>
      <meta
        name="description"
        content="Easily pay your ISBM University fees online with a secure, hassle-free process. Quick transactions ensure a smooth academic experience."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Pay Fee Online</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Pay Fee Online
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="payment-content ptb-50">
        <div className="container-xxl">
          <Row>
            <Col lg={12}>
              <Card className="border-0 shadow mb-5">
                <Card.Body className="p-4">
                  <p className="text-blue  fs-5">
                    ISBM University has multiple options available for efficient
                    and secured fee payment for students. Details regarding the
                    different modes of fee payment for students are given below.
                  </p>
                </Card.Body>
              </Card>

              {/* Payment Modes */}
              <div className="payment-modes mb-5">
                <h2 className="modern-title section-title-start text-blue">
                  <i className="ti ti-credit-card me-2"></i>
                  Fees Payment Mode
                </h2>
                <p className="mb-4">
                  Fees can be paid in either of the following modes:
                </p>

                <Row className="g-4 rows-cols-lg-5 rows-cols-md-3 rows-cols-sm-2">
                  <Col>
                    <Card className="h-100 common-card shadow">
                      <Card.Body className="text-center">
                        <div className="payment-icon mb-3">
                          <i className="ti ti-cash fs-1 text-purple"></i>
                        </div>
                        <Card.Title className="text-blue">Cash</Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col>
                    <Card className="h-100 common-card shadow">
                      <Card.Body className="text-center">
                        <div className="payment-icon mb-3">
                          <i className="ti ti-file-invoice fs-1 text-purple"></i>
                        </div>
                        <Card.Title className="text-blue">
                          Cheque/Demand Draft
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col>
                    <Card className="h-100 common-card shadow">
                      <Card.Body className="text-center">
                        <div className="payment-icon mb-3">
                          <i className="ti ti-credit-card fs-1 text-purple"></i>
                        </div>
                        <Card.Title className="text-blue">
                          Credit Card
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col>
                    <Card className="h-100 common-card shadow">
                      <Card.Body className="text-center">
                        <div className="payment-icon mb-3">
                          <i className="ti ti-building-bank fs-1 text-purple"></i>
                        </div>
                        <Card.Title className="text-blue">
                          Online Bank Transfer
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col>
                    <Card className="h-100 common-card shadow">
                      <Card.Body className="text-center">
                        <div className="payment-icon mb-3">
                          <i className="ti ti-credit-card-off fs-1 text-purple"></i>
                        </div>
                        <Card.Title className="text-blue">
                          Online Credit Card Transfer
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <p className="mt-4">
                  Please get in touch at{" "}
                  <a
                    href="mailto:admissions@isbmuniversity.edu.in"
                    className="text-purple"
                  >
                    admissions@isbmuniversity.edu.in
                  </a>{" "}
                  for further details
                </p>
              </div>

              {/* Important Information */}
              <div className="important-info">
                <h2 className="modern-title section-title-start text-blue">
                  <i className="ti ti-alert-circle me-2"></i>
                  Other Related Important Information
                </h2>

                <ListGroup variant="flush">
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">
                      1
                    </Badge>
                    <span>You can opt for more than one course at a time.</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">
                      2
                    </Badge>
                    <span>Fees are subject to revision at any time.</span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">
                      3
                    </Badge>
                    <span>
                      Course once selected will not be changed under any
                      circumstance.
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">
                      4
                    </Badge>
                    <span>
                      You can change the course while taking admission or the
                      same day of admission till the working hours.
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">
                      5
                    </Badge>
                    <span>
                      Full fees has to be paid at the time of admission.
                    </span>
                  </ListGroup.Item>
                  <ListGroup.Item className="d-flex align-items-start">
                    <Badge bg="blue" className="me-3 mt-1">
                      6
                    </Badge>
                    <span>
                      Fees once paid is not refundable under any circumstance.
                    </span>
                  </ListGroup.Item>
                </ListGroup>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="payment-form-container">
                <div className="text-center mb-5">
                  <h2 className="modern-title text-blue">Online Fee Payment</h2>
                  <p className="fw-semibold">
                    Secure and convenient payment portal for students
                  </p>
                  <div className="header-divider">
                    <span className="divider-line"></span>
                    <i className="ti ti-credit-card"></i>
                    <span className="divider-line"></span>
                  </div>
                </div>

                <div className="form-body">
                  <Form id="tnpForm">
                    <div className="row g-4 mb-4">
                      <div className="col-md-6">
                        <div className="form-card">
                          <h4 className="form-section-title text-blue">
                            <i className="ti ti-user-circle me-2"></i>
                            Personal Information
                          </h4>
                          <Form.Group className="mb-3">
                            <Form.Label className="form-label">
                              Full Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              id="name1"
                              name="name1"
                              placeholder="Enter full name"
                            />
                          </Form.Group>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicEmail"
                          >
                            <Form.Label className="form-label">
                              Email Address
                            </Form.Label>
                            <Form.Control
                              required
                              type="text"
                              id="email1"
                              name="email"
                              placeholder="Enter email Address"
                            />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label className="form-label">
                              Mobile Number
                            </Form.Label>
                            <Form.Control
                              required
                              type="text"
                              id="phone1"
                              name="phone"
                              placeholder="Enter Mobile Number"
                            />
                          </Form.Group>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-card">
                          <h4 className="form-section-title">
                            <i className="ti ti-school me-2"></i>
                            Academic Information
                          </h4>
                          <Form.Group className="mb-3">
                            <Form.Label className="form-label">
                              Counselor Name
                            </Form.Label>
                            <Form.Control
                              required
                              id="counselor1"
                              type="text"
                              placeholder="Enter Counselor Name"
                            />
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label className="form-label">
                              Courses
                            </Form.Label>
                            <Form.Select
                              required
                              name="course1"
                              id="course1"
                              className="form-select form-control"
                            >
                              <CourseList />
                            </Form.Select>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label className="form-label">
                              Payment Amount (₹)
                            </Form.Label>
                            <div className="input-group">
                              <span className="input-group-text">₹</span>
                              <Form.Control
                                required
                                type="text"
                                id="amount1"
                                name="amount"
                                placeholder="Enter Amount"
                              />
                            </div>
                          </Form.Group>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="form-card">
                          <h4 className="form-section-title">
                            <i className="ti ti-notes me-2"></i>
                            Additional Information
                          </h4>
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Label className="form-label">
                              Comments
                            </Form.Label>
                            <Form.Control
                              required
                              as="textarea"
                              id="comment1"
                              name="comment1"
                              placeholder="Enter Comment"
                              rows={4}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </Form>

                  <Form id="tnpForm1" method="POST">
                    <input
                      type="hidden"
                      value="51f1c2bf-8654-4215-8ee4-5bf4ef779955"
                      name="api_key"
                    />
                    <input type="hidden" value="" name="hash" />
                    <input
                      type="hidden"
                      value="https://isbmuniversity.edu.in/api/payment_response.php"
                      name="return_url"
                    />
                    <input type="hidden" value="LIVE" name="mode" />
                    <input type="hidden" value="" name="order_id" />
                    <input type="hidden" value="" name="amount" />
                    <input type="hidden" value="INR" name="currency" />
                    <input
                      type="hidden"
                      value="Payment Gateway"
                      name="description"
                    />
                    <input type="hidden" value="" name="name" />
                    <input type="hidden" value="" name="email" />
                    <input type="hidden" value="" name="phone" />
                    <input
                      type="hidden"
                      value="Lalji Pada"
                      name="address_line_1"
                    />
                    <input
                      type="hidden"
                      value="Kandivali West"
                      name="address_line_2"
                    />
                    <input type="hidden" value="Mumbai" name="city" />
                    <input type="hidden" value="Maharashtra" name="state" />
                    <input type="hidden" value="400051" name="zip_code" />
                    <input type="hidden" value="India" name="country" />
                    <input type="hidden" value="" name="udf1" />
                    <input type="hidden" value="" name="udf2" />
                    <input type="hidden" value="" name="udf3" />
                    <input type="hidden" value="" name="udf4" />
                    <input type="hidden" value="" name="udf5" />
                    <div className="col-12">
                      <div className="payment-actions text-center">
                        <Button
                          type="button"
                          className="btn-pay-now"
                          data-bs-toggle="modal"
                          data-bs-target="#paymentModal"
                        >
                          <i className="ti ti-currency-rupee me-2"></i>
                          Proceed to Payment
                        </Button>
                        <p className="payment-security-note mt-3">
                          <i className="ti ti-shield-check me-2"></i>
                          Your information is secure with 256-bit encryption
                        </p>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        className="modal fade"
        id="paymentModal"
        tabIndex="-1"
        aria-labelledby="paymentModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg">
            <div className="modal-header p-3 border-0 bg-blue text-white rounded-top">
              <h5
                className="modal-title fs-5 fw-semibold"
                id="paymentModalLabel"
              >
                Select Payment Method
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body p-4">
              <p className="text-muted mb-4 text-center">
                Choose your preferred payment gateway
              </p>
              <div className="d-flex flex-column flex-md-row justify-content-center gap-4">
                {/* Razorpay Option */}

                <div
                  className="payment-option p-3 border rounded-3 text-center hover-shadow"
                  style={{
                    cursor: "pointer",
                    borderColor: "#6366f1 !important",
                  }}
                  onClick={(e) => {
                    document.getElementById("paymentModalCloseBtn")?.click();
                    handleRazorpay(e);
                  }}
                >
                  <div className="payment-logo bg-light p-3 rounded-3 mb-3">
                    <img src={razorpay} alt="Razorpay" className="img-fluid" />
                  </div>
                  <h6 className="fw-medium mb-1">Razorpay</h6>
                </div>

                {/* BasisPay Option */}
                <div
                  className="payment-option p-3 border rounded-3 text-center hover-shadow"
                  style={{
                    cursor: "pointer",
                    borderColor: "#6366f1 !important",
                  }}
                  onClick={(e) => {
                    document.getElementById("paymentModalCloseBtn")?.click();
                    getData(e);
                  }}
                >
                  <div className="payment-logo bg-light p-3 rounded-3 mb-3">
                    <img src={basispay} alt="BasisPay" className="img-fluid" />
                  </div>
                  <h6 className="fw-medium mb-1">BasisPay</h6>
                </div>
              </div>

              <div className="mt-4 text-center">
                <small className="text-muted">
                  <i className="bi bi-lock-fill me-1"></i> All transactions are
                  secure and encrypted
                </small>
              </div>

              <button
                type="button"
                id="paymentModalCloseBtn"
                className="d-none"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OnlinePayment;
